import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class BookService {

  constructor(
    private requestService: RequestService
  ) { }

  GetDefaultData(CompanyID:string,UserID:string){
    var param = {
      "CompanyID": CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/Accommodation/GetDefaultData',param);
  }
  /**取得住宿狀況，確認空房 */
  GetBooked(model:any){
    return this.requestService.Post<any>(environment.baseUrl + '/Accommodation/GetBooked',model);
  }
  /**新增住宿資料 */
  CreateBook(model:any){
    //新增預約
    return this.requestService.Post<any>(environment.baseUrl + '/Accommodation/CreateBook',model);
  }

  GetConsentForm(CompanyID:string){
    var param = {
      "CompanyID": CompanyID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/Accommodation/GetConsentForm',param);
  }
  SaveSign(model:any){
    return this.requestService.Post<any>(environment.baseUrl + '/Accommodation/SaveSign',model);
  }
}
